import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { getSiteInfo } from '../api/site'

/** 默认站点名称与描述，发布时按产品类型替换（见 publish/type/*.json） */
export const DEFAULT_SITE_NAME = 'MUSEX'
export const DEFAULT_SITE_DESCRIPTION = 'Voice & Digital Human Synthesis'

/**
 * 站点信息全局状态。
 * 由后端 /api/system/site 提供；未设置时回退到默认名称与描述。
 */
export const useSiteStore = defineStore('site', () => {
  const name = ref('')
  const description = ref('')
  const loaded = ref(false)

  const displayName = computed(() => name.value.trim() || DEFAULT_SITE_NAME)
  const displayDescription = computed(() => description.value.trim() || DEFAULT_SITE_DESCRIPTION)

  let loading: Promise<void> | null = null

  const load = (): Promise<void> => {
    if (loading) return loading
    loading = getSiteInfo()
      .then((info) => {
        name.value = info.name || ''
        description.value = info.description || ''
      })
      .catch(() => {
        // 接口不可用时保留默认名称，不影响页面渲染
      })
      .finally(() => {
        loaded.value = true
        loading = null
      })
    return loading
  }

  const ensureLoaded = async () => {
    if (!loaded.value) await load()
  }

  const setInfo = (nextName: string, nextDescription: string) => {
    name.value = nextName
    description.value = nextDescription
    loaded.value = true
  }

  return { name, description, displayName, displayDescription, loaded, load, ensureLoaded, setInfo }
})
